var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex",attrs:{"id":"app"}},[_c('navigation'),_c('transition',{attrs:{"name":"crossfade","mode":"out-in"},on:{"after-leave":function($event){return _vm.$root.$emit('triggerScroll')}}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }